import { getSnapshot } from "mobx-state-tree";
import { isEqual } from "underscore";

/**
 * @summary Removes all 'undefined' props from the parsed model and returns the result
 * @param model
 */
export const filterUndefinedProps = (model) => {
    const filteredModel = { ...model };
    Object.keys(model).forEach((key) => {
        if (filteredModel[key] === undefined) {
            delete filteredModel[key];
        }
    });
    return filteredModel;
};

/**
 * @summary Returns certain properties derived from a patch path
 * @param patch
 */
export const getPatchProps = (patch) => {
    const pathSegments = patch.path.split(`/`);
    const rootPath = `/${pathSegments[1]}`;
    const patchId = pathSegments[2];
    const propKey = pathSegments[3];
    return { pathSegments, rootPath, patchId, propKey };
};

/**
 * @summary Compare a store with a data object and return boolean result
 * @param currentData
 * @param newData
 * @param filterUndefined = false
 */
export const hasChanged = (
    store,
    newData,
    filterUndefined = false
): boolean => {
    const data = getSnapshot(store);
    return filterUndefined
        ? !isEqual(filterUndefinedProps(data), newData)
        : !isEqual(data, newData);
};
